import React, {
  HTMLAttributes,
  PropsWithChildren,
  ReactNode,
  SyntheticEvent,
} from "react";
import { useTheme } from "styled-components";

import { CaretRight } from "@ui/Assets/Symbolicons";
import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { SectionMenuStyles } from "./SectionMenu.styles";

interface Props extends HTMLAttributes<HTMLUListElement> {
  children?: React.ReactNode;
}

export const SectionMenu = (props: Props): React.ReactElement => {
  const { children, ...rest } = props;

  return <ul {...rest}>{children}</ul>;
};

interface Props {
  testId?: string;
  hasLink?: boolean;
  icon?: ReactNode;
  onClick?: (e: SyntheticEvent<HTMLElement>) => void;
}

const Item = (props: PropsWithChildren<Props>) => {
  const theme = useTheme();

  return (
    <TestWrapper testId={props.testId}>
      <SectionMenuStyles.Item onClick={props.onClick}>
        {props.icon && (
          <SectionMenuStyles.Icon>{props.icon}</SectionMenuStyles.Icon>
        )}

        {props.children && (
          <SectionMenuStyles.Text>{props.children}</SectionMenuStyles.Text>
        )}

        {props.hasLink && (
          <SectionMenuStyles.Arrow>
            <CaretRight size={24} color={theme.palette.grey600} />
          </SectionMenuStyles.Arrow>
        )}
      </SectionMenuStyles.Item>
    </TestWrapper>
  );
};

SectionMenu.Item = Item;
